<template>
  <div class="body">
    <!-- 退货待扫描 -->
    <baseBreadcrumb :page="$t('message.returnScan')" :menu="$t('message.followUpTheReplacementPackage')" />
    <div class="body">
      <div class="search">
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')"></el-input>
        </div>
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')"></el-input>
        </div>
        <!-- 退换货物流号 -->
        <div class="item">
          <el-input v-model="datas.refund_express_no"
            :placeholder="$t('message.returnAndExchangeLogisticsNumber')"></el-input>
        </div>
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 按钮 -->
        <div class="item">
          <el-button type="primary" @click="search">{{
            $t("message.filter")
          }}</el-button>
          <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  退换货编号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeNumber')" prop="refund_sn" width="150px">
          </el-table-column>
          <!-- 打印时间 -->
          <el-table-column align="center" :label="$t('message.printTime')" prop="print_at" width="100px">
          </el-table-column>
          <!--  打包时间-->
          <el-table-column align="center" :label="$t('message.packingTimeDB')" prop="pack_at" width="100px">
          </el-table-column>

          <!--  提出时间-->
          <el-table-column align="center" :label="$t('message.forwardTime')" prop="created_at" width="100px">
          </el-table-column>
          <!--  采购员-->
          <el-table-column align="center" :label="$t('message.buyer')" prop="g_admin.realname" width="100">
          </el-table-column>
          <!--  配货员-->
          <el-table-column align="center" :label="$t('message.distributionMember')" prop="p_admin.realname" width="100">
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" :label="$t('message.orderNumber')" prop="" width="170px">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" target="_blank"
                  style="color: #fa5058">{{ scope.row.order_sn }}</router-link>
              </p>
              <!-- <p>
                {{
                  scope.row.order_purchase_refund_detail.order_purchase.realname
                }}
              </p> -->
            </template>
          </el-table-column>
          <!--  交易号-->
          <el-table-column align="center" :label="$t('message.transactionNumber')" prop="purchase_no">
          </el-table-column>
          <!--  退换货类别-->
          <el-table-column align="center" :label="$t('message.typeOfReturnOrExchange')" prop="type_name" width="110px">
            <template slot-scope="scope">
              <span :style="{
                color: scope.row.refund_type == 1 ? '#FA5058' : '#2C96E7',
              }">{{ scope.row.type_name }}</span>
            </template>
          </el-table-column>
          <!--  退换货数量-->
          <el-table-column align="center" :label="$t('message.quantityOfReturnAndReplacement')" prop="refund_num_total"
            width="110px">
          </el-table-column>
          <!--  商品明细-->
          <el-table-column align="center" :label="$t('message.detailsOfGoods')" prop="rowNumber">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="look(scope.row)">{{
                $t("message.look")
              }}</el-button>
            </template>
          </el-table-column>
          <!--  退换货物流号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeLogisticsNumber')" prop="rowNumber">
            <template slot-scope="scope">
              <div class="template">
                <p v-for="(express, expressIndex) in scope.row.expressSet" :key="expressIndex">
                  {{ express }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="110px">
            <template slot-scope="scope">
              <!-- 退回待打印 -->
              <p>
                <el-button size="small" type="success" class="primary" @click="refundUnPrint(scope.row.refund_sn)"
                  v-if="isAuth(289)">{{
                    $t("message.returnToPrint") }}</el-button>
              </p>
              <!-- 删除 -->
              <p>
                <el-button size="small" type="success" class="dark" @click="refundDelete(scope.row.refund_sn)"
                  v-if="isAuth(286)">{{
                    $t("message.delete") }}</el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看商品详情 -->
    <detailsGoodsDialogVisible :list="itemData" v-if="detailsGoodsDialogVisible" />
  </div>
</template>
<script>
import detailsGoodsDialogVisible from "../components/goodsDetails";

export default {
  data() {
    return {
      val: "",
      tableData: [],
      show: true,
      datas: {
        page: 1,
        pageSize: 10,
        status: 12,
        order_sn: "",
        purchase_no: "",
        dateStart: "",
        dateEnd: "",
      },
      total: 0,
      detailsGoodsDialogVisible: false,
      returnAndExchangeEditorDialogVisible: false,
      itemData: [],
    };
  },
  components: {
    detailsGoodsDialogVisible,
  },
  created() {
    this.refundList();
  },
  methods: {
    refundList() {
      this.$api.signInApi.refundList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(this.tableData);
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.refundList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 10,
        status: 12,
        order_sn: "",
        purchase_no: "",
        dateStart: "",
        dateEnd: "",
      };
      this.refundList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.refundList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.refundList();
    },
    // 查看
    look(item) {
      this.itemData = JSON.parse(
        JSON.stringify(item.order_purchase_refund_detail)
      );
      this.detailsGoodsDialogVisible = true;
    },
    // 退回待打印
    refundUnPrint(refund_sn) {
      this.$confirm(
        this.$t("message.isReturnToPrint"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.refundUnPrint({ refund_sn }).then((res) => {
            this.$message.success(res.msg);
            this.refundList();
          });
        })
        .catch(() => { });
    },
    // -删除
    refundDelete(refund_sn) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.refundDelete({ refund_sn }).then((res) => {
            this.$message.success(res.msg);
            this.refundList();
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
    }
  }

  .primary {
    padding: 9px 0;
  }
}
</style>